
import { computed, defineComponent, reactive } from 'vue';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoCliente from '@/servicos/ServicoCliente';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';

export default defineComponent({
  name: 'ComboCliente',
  props: {
    multiplaSelecao: {
      type: Boolean,
      default: false,
    },
    codigo: {
      type: Number || undefined,
    },
    codigos: {
      type: Array as () => number[],
      default: () => [],
    },
    ignorarCodigos: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite o nome/razão social do cliente, CPF/CNPJ ou Código do ERP',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigo', 'update:codigos', 'change'],
  setup(props, { emit }) {
    let debounce = 0;
    const servicoCliente = new ServicoCliente();

    const state = reactive({
      itensBuscaRapida: [] as IItemBuscaRapida[],
      buscando: false,
      digitando: false,
    });

    async function obterPorCodigo(valor: any) {
      if (state.digitando) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }

      if (props.multiplaSelecao) {
        if (props.codigos.length === 0) { return; }
      } else if (props.codigo === 0) {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.itensBuscaRapida)) {
        if (props.multiplaSelecao) {
          const listaCodigosConsulta = state.itensBuscaRapida.map((c) => c.codigo);
          const diferencas = props.codigos.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.itensBuscaRapida.find((c) => c.codigo === props.codigo);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }
      }

      if (!efetuarConsulta) return;

      const parametrosBuscaRapida: IParametrosBuscaRapida = { apenasAtivos: false };
      parametrosBuscaRapida.parceiros = [];
      parametrosBuscaRapida.valor = '';
      parametrosBuscaRapida.valores = [];
      parametrosBuscaRapida.filtrarPorVariosCodigos = false;
      parametrosBuscaRapida.filtrarPorCodigo = false;
      parametrosBuscaRapida.quantidadeRegistros = 10;
      if (props.multiplaSelecao) {
        parametrosBuscaRapida.filtrarPorVariosCodigos = true;
        parametrosBuscaRapida.valores = valor;
      } else {
        parametrosBuscaRapida.filtrarPorCodigo = true;
        parametrosBuscaRapida.valor = valor;
      }

      state.itensBuscaRapida = await servicoCliente.buscaRapida(parametrosBuscaRapida);
      if (!UtilitarioGeral.validaLista(state.itensBuscaRapida)) {
        if (props.multiplaSelecao) {
          emit('update:codigos', undefined);
        } else {
          emit('update:codigo', undefined);
        }
      }
    }

    async function pesquisar(valor: any) {
      state.digitando = true;

      state.buscando = true;
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosBuscaRapida: IParametrosBuscaRapida = { valor, apenasAtivos: true };
        parametrosBuscaRapida.parceiros = [];
        parametrosBuscaRapida.valores = [];
        parametrosBuscaRapida.filtrarPorVariosCodigos = false;
        parametrosBuscaRapida.filtrarPorCodigo = false;
        parametrosBuscaRapida.quantidadeRegistros = 10;

        state.itensBuscaRapida = await servicoCliente.buscaRapida(parametrosBuscaRapida);
        if (props.ignorarCodigos.length > 0) {
          props.ignorarCodigos.forEach((codigo) => {
            state.itensBuscaRapida = state.itensBuscaRapida.filter((c) => c.codigo !== codigo);
          });
        }
        state.buscando = false;
      }, 600);
    }

    function obterCliente():any {
      obterPorCodigo(props.codigo);
      return props.codigo;
    }

    const computedCodigo = computed({
      get: () => obterCliente(),
      set: (val: number) => {
        emit('update:codigo', val);
      },
    });

    function obterClientes():number[] {
      obterPorCodigo(props.codigos);
      return props.codigos;
    }

    const computedCodigos = computed({
      get: () => obterClientes(),
      set: (val: number[]) => {
        emit('update:codigos', val);
      },
    });

    function changeMultiplos() {
      emit('change', props.codigos);
    }

    function change() {
      emit('change', props.codigo);
    }

    function montaApresentacaoCliente(cliente: IItemBuscaRapida) {
      let apresentacao = '';

      if (cliente.informacaoAdicional.length === 11) {
        apresentacao += `CPF: ${UtilitarioMascara.mascararCPF(cliente.informacaoAdicional)}`;
      } else {
        apresentacao += `CNPJ: ${UtilitarioMascara.mascararCNPJ(cliente.informacaoAdicional)}`;
      }
      apresentacao += ` ${cliente.textoIdentificacao}`;
      return apresentacao;
    }
    return {
      props,
      state,
      computedCodigo,
      computedCodigos,
      pesquisar,
      change,
      changeMultiplos,
      montaApresentacaoCliente,
    };
  },
});
